export default __webpack_public_path__ + "static/media/1825.c218c40c.png";